(function () {
  var DOMAIN_ID = 10198674;
  var PAGE_SIZE = 6;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var STAR_SVG = '<svg class="pdp-star-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path fill="none" d="M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"></path></svg>';

  var state = { reviews: [], summary: {}, pages: 0, page: 1 };

  function buildStarRow(emptyEl, filledEl) {
    if (!emptyEl || !filledEl) return;
    var html = '';
    for (var i = 0; i < 5; i++) html += '<span class="pdp-star">' + STAR_SVG + '</span>';
    emptyEl.innerHTML = html;
    filledEl.innerHTML = html;
  }

  function setSummary() {
    var avg = state.summary.avg || 0;
    var count = state.summary.count || 0;
    var text = count > 1 ? 'Based on ' + count + ' reviews' : 'Based on ' + count + ' review';

    // Header rating block (above price in product meta)
    var headerEl = document.querySelector('.pdp-rating');
    if (headerEl) {
      buildStarRow(
        headerEl.querySelector('.pdp-empty-stars .pdp-stars'),
        headerEl.querySelector('.pdp-filled-stars .pdp-stars')
      );
      var hFilled = headerEl.querySelector('.pdp-filled-stars');
      if (hFilled) hFilled.style.width = (avg * 20) + '%';
      var hCount = headerEl.querySelector('.pdp-review-count');
      if (hCount) hCount.textContent = text;
      headerEl.style.display = count ? '' : 'none';
    }

    // Rating block inside reviews accordion panel
    var blockEl = document.querySelector('#pdp-reviews .pdp-rating-block');
    if (blockEl) {
      buildStarRow(
        blockEl.querySelector('.pdp-empty-stars .pdp-stars'),
        blockEl.querySelector('.pdp-filled-stars .pdp-stars')
      );
      var bFilled = blockEl.querySelector('.pdp-filled-stars');
      if (bFilled) bFilled.style.width = (avg * 20) + '%';
      var bCount = blockEl.querySelector('.pdp-review-count');
      if (bCount) bCount.textContent = text;
    }
  }

  function buildReviewHTML(r) {
    var date = new Date(r.createdAt);
    var dateStr = MONTHS[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
    var rating = r.rating || r.star || 0;
    var stars = '';
    for (var i = 0; i < 5; i++) {
      stars += '<span class="pdp-star ' + (i < rating ? 'pdp-full-star' : 'pdp-empty-star') + '">' + STAR_SVG + '</span>';
    }
    return '<div class="pdp-review"><div class="pdp-review-wrap">' +
      '<div class="pdp-rvwrating"><div class="pdp-stars">' + stars + '</div></div>' +
      '<div class="pdp-rvwtitle"><span class="pdp-rvw-title">' + (r.title || '') + '</span></div>' +
      '<div class="pdp-rvwreviewed"><span class="pdp-rvw-reviewed">' +
        '<span class="pdp-reviewed-by">' + (r.username || 'Customer') + '</span>' +
        ' on <span class="pdp-reviewed-on">' + dateStr + '</span>' +
      '</span></div>' +
      '<div class="pdp-rvwreview"><span class="pdp-rvw-review">' + (r.review || r.title || '') + '</span></div>' +
    '</div></div>';
  }

  function setReviews() {
    var list = document.querySelector('#pdp-reviews .pdp-reviews-list');
    if (!list) return;
    var end = state.page * PAGE_SIZE;
    var start = end - PAGE_SIZE;
    var html = '';
    state.reviews.slice(start, end).forEach(function (r) { html += buildReviewHTML(r); });
    list.innerHTML = html;
  }

  function scrollToReviews() {
    var container = document.getElementById('pdp-reviews');
    if (!container) return;
    var hHeight = 0;
    var header = document.getElementById('shopify-section-header');
    if (header) {
      var rect = header.getBoundingClientRect();
      var pos = header.style.position || window.getComputedStyle(header).position;
      if (pos === 'fixed' || pos === 'sticky') hHeight = rect.bottom;
    }
    window.scrollTo({ top: container.getBoundingClientRect().top + window.pageYOffset - hHeight, behavior: 'smooth' });
  }

  function setPaginationItem(label) {
    var li = document.createElement('li');
    li.className = 'pdp-pgn-item';
    if (label === state.page) li.classList.add('pdp-pgn-active');

    var inner = document.createElement('span');
    inner.className = 'pdp-pgn-label';
    inner.textContent = label;

    if (label !== '...' && label !== state.page) {
      var a = document.createElement('a');
      a.className = 'pdp-pgn-link';
      a.setAttribute('href', '#pdp-reviews?page=' + label);
      a.setAttribute('aria-label', 'go to review page ' + label);
      a.setAttribute('data-page', label);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        state.page = Number(a.getAttribute('data-page'));
        li.classList.add('pdp-pgn-active');
        var siblings = li.parentElement ? Array.prototype.slice.call(li.parentElement.children) : [];
        siblings.forEach(function (s) { if (s !== li) s.classList.remove('pdp-pgn-active'); });
        setReviews();
        setPagination();
        setTimeout(scrollToReviews, 100);
        try { campaign.trigger('Clicked.pagination'); } catch (e2) {}
      });
      a.appendChild(inner);
      li.appendChild(a);
    } else {
      li.appendChild(inner);
    }
    return li;
  }

  function setPagination() {
    var container = document.getElementById('pdp-reviews');
    if (!container) return;
    var itemsEl = container.querySelector('.pdp-pgn-items');
    var prevNav = container.querySelector('.pdp-pgnprev');
    var nextNav = container.querySelector('.pdp-pgnnext');
    var prevBtn = container.querySelector('.pdp-pgn-prev');
    var nextBtn = container.querySelector('.pdp-pgn-next');
    if (!itemsEl) return;

    itemsEl.innerHTML = '';

    if (state.page === 1) {
      prevNav && prevNav.classList.add('pdp-visually-hide');
    } else {
      prevNav && prevNav.classList.remove('pdp-visually-hide');
      prevBtn && prevBtn.setAttribute('data-page', state.page - 1);
    }

    if (state.pages <= 9) {
      for (var i = 1; i <= state.pages; i++) itemsEl.appendChild(setPaginationItem(i));
    } else if (state.page <= 5) {
      for (var i = 1; i <= 7; i++) itemsEl.appendChild(setPaginationItem(i));
      itemsEl.appendChild(setPaginationItem('...'));
      itemsEl.appendChild(setPaginationItem(state.pages));
    } else if (state.page > state.pages - 5) {
      itemsEl.appendChild(setPaginationItem(1));
      itemsEl.appendChild(setPaginationItem('...'));
      for (var i = state.pages - 6; i <= state.pages; i++) itemsEl.appendChild(setPaginationItem(i));
    } else {
      itemsEl.appendChild(setPaginationItem(1));
      itemsEl.appendChild(setPaginationItem('...'));
      for (var i = state.page - 2; i <= state.page + 2; i++) itemsEl.appendChild(setPaginationItem(i));
      itemsEl.appendChild(setPaginationItem('...'));
      itemsEl.appendChild(setPaginationItem(state.pages));
    }

    if (state.page !== state.pages) {
      nextNav && nextNav.classList.remove('pdp-visually-hide');
      nextBtn && nextBtn.setAttribute('data-page', state.page + 1);
    } else {
      nextNav && nextNav.classList.add('pdp-visually-hide');
    }
  }

  function bindNavigation() {
    var container = document.getElementById('pdp-reviews');
    if (!container) return;

    var prevBtn = container.querySelector('.pdp-pgn-prev');
    var nextBtn = container.querySelector('.pdp-pgn-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        state.page = Number(prevBtn.getAttribute('data-page')) || 1;
        setReviews();
        setPagination();
        setTimeout(scrollToReviews, 100);
        try { campaign.trigger('Clicked.previous'); } catch (e2) {}
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        state.page = Number(nextBtn.getAttribute('data-page')) || 1;
        setReviews();
        setPagination();
        setTimeout(scrollToReviews, 100);
        try { campaign.trigger('Clicked.next'); } catch (e2) {}
      });
    }

    // Header rating click → open reviews tab and scroll
    var headerLink = document.querySelector('.pdp-rating .pdp-review-link');
    if (headerLink) {
      headerLink.addEventListener('click', function (e) {
        e.preventDefault();
        // Open (never close) the reviews accordion tab and smooth-scroll to
        // its header — window.pdpOpenAccordionTab (assets/pdp-accordion.js)
        // handles both, so a second click on this badge re-scrolls instead of
        // collapsing the tab the way a raw reviewHead.click() toggle did.
        if (typeof window.pdpOpenAccordionTab === 'function') {
          window.pdpOpenAccordionTab('.acc-head.review');
        }
        try { campaign.trigger('Clicked.rating'); } catch (e2) {}
      });
    }
  }

  function initReviews(data) {
    var reviews = (data.reviews || []).filter(function (r) {
      return r.rating && r.username && r.rating == 5;
    });
    state.reviews = reviews.slice(0, 12);
    state.summary = data.summary || {};

    if (state.reviews.length) {
      state.pages = Math.ceil(state.reviews.length / PAGE_SIZE);
    }

    var container = document.getElementById('pdp-reviews');
    if (!container) return;

    if (state.summary.count) setSummary();

    if (state.reviews.length) {
      var noReviews = container.querySelector('.pdp-noreviews');
      if (noReviews) noReviews.remove();
    } else {
      var reviewsMain = container.querySelector('.pdp-reviews-main');
      if (reviewsMain) reviewsMain.remove();
    }

    setReviews();

    var pagination = container.querySelector('.pdp-pagination');
    if (state.pages > 1) {
      if (pagination) pagination.classList.remove('pdp-visually-hidden');
      setPagination();
    } else {
      if (pagination) pagination.classList.add('pdp-visually-hidden');
    }

    bindNavigation();
  }

  function start() {
    var container = document.getElementById('pdp-reviews');
    if (!container) return;
    var productId = container.getAttribute('data-product-id');
    if (!productId) return;

    var url = '//t.convertcart.com/review/' + DOMAIN_ID + '/product/list/' + productId + '?page=1&pageSize=100';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) { initReviews(data); })
      .catch(function (err) { console.warn('[pdp-reviews] fetch failed', err); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
